/* Elemence Hustler — cross-column row-hover sync. Hovering a row in either
   column highlights the same-index row in BOTH columns. */
(function () {
  function initSection(section) {
    if (!section || section.dataset.hustlerInit === '1') return;
    section.dataset.hustlerInit = '1';

    const grid = section.querySelector('.elemence-hustler__grid');
    if (!grid) return;

    const lists = grid.querySelectorAll('.elemence-hustler__list');
    if (lists.length < 2) return;

    const rows = new Map();
    lists.forEach((ul) => {
      [...ul.children].forEach((li, i) => {
        if (!rows.has(i)) rows.set(i, []);
        rows.get(i).push(li);
      });
    });

    rows.forEach((lis) => {
      const on  = () => lis.forEach((li) => li.classList.add('is-row-hover'));
      const off = () => lis.forEach((li) => li.classList.remove('is-row-hover'));
      lis.forEach((li) => {
        li.addEventListener('mouseenter', on);
        li.addEventListener('mouseleave', off);
      });
    });
  }

  function initAll(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.elemence-hustler').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
